import { render, staticRenderFns } from "./163.vue?vue&type=template&id=4e8d4480&scoped=true&"
import script from "./163.vue?vue&type=script&lang=js&"
export * from "./163.vue?vue&type=script&lang=js&"
import style0 from "./163.vue?vue&type=style&index=0&id=4e8d4480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8d4480",
  null
  
)

export default component.exports